<template>
  <div class="hello">
    <van-nav-bar
      style="background-color: #3f78f6; margin-bottom: 0rem; border: 0"
      title=""
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    >
      <template #title>
        <span style="color: white; font-size: 0.4rem">我的信息</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" color="white" size="18" />
      </template>
    </van-nav-bar>
    <van-form class="van-form" style="margin-top: 20px" @submit="onSubmit">
      <van-image
      round
        show-loading
        fit="fill"
        width="1.8rem"
        height="1.8rem"
        style="margin: 0.7rem 2rem 0.7rem 0.83rem"
        radius
       :src="imageurl"
      >
        <!-- <template v-slot:loading>
    <van-loading type="spinner" size="20" />
  </template> -->
      </van-image>
       <van-field
        v-model="dep"
        label="部门"
        name="dep"
        readonly
      />
      <van-field
        v-model="number"
        label="工号"
        name="number"
        placeholder="请输入工号"
        readonly
      />
      <van-field
        v-model="username"
        label="姓名"
        name="username"
        placeholder="请输学生姓名"
        readonly
      />
      <van-field
        v-model="phone"
        label="手机号"
        name="phone"
        placeholder="请输入手机号"
        readonly
      />
    </van-form>
    <van-tabbar  fixed>
      <van-tabbar-item  to="TeacherPass"> 修改密码</van-tabbar-item>
      <van-tabbar-item  :to=" { path: 'TeacherImage', query: {student: this.student, page: this.page }}"> 上传照片</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dep:"",
      username: "",
      phone: "",
      number: "",
      xiaoqu: "",
      imageurl:"",
      student: "",
      page: "",
    };
  },
  created() {
    this.student = this.$route.query.student;
    this.page = this.$route.query.page;
    this.xiaoqu = this.$route.query.xiaoqu;
    var json = window.localStorage.getItem("User");
    var jsonObj = JSON.parse(json);
    this.username = jsonObj[0]["username"];
    this.phone = jsonObj[0]["phone"];
    this.number = jsonObj[0]["number"];
    this.dep=jsonObj[0]["dep"];
     this.imageurl =window.localStorage.getItem(this.student); 
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
      var json = window.localStorage.getItem("User");
      var jsonObj = JSON.parse(json);
      console.log("身份:" + jsonObj[0]["shenfen"]);
      var code;
      if (jsonObj[0]["shenfen"] == "老师") {
        code = jsonObj[0]["number"];
      } else if (jsonObj[0]["shenfen"] == "学生") {
        code = jsonObj[0]["number"];
      } else {
        code = jsonObj[0]["phone"];
      }
      var params_json = {
        userid: code,
        action: "parentStudentBind",
        param1: values.number,
        param2: values.username,
        param3: "",
        param4: "",
        param5: "",
        // param4:this.openId
      };
      this.$http.post("/web/save", params_json).then(function (res) {
        let obj = res.data;
        console.log("注册后返回消息:" + obj.msg);
        if (obj.msg == "0") {
          this.$notify({
            type: "success",
            message: "注册成功。",
          });
          setTimeout(() => {
            this.$router.push("StudentIndex");
          }, 3000);
        } else {
          this.$notify({
            type: "warning",
            message: obj.msg,
          });
          // location.reload();
        }
      });
    },
    onClickLeft() {
      this.$router.push({
        path: "Index",
        query: {
          page: this.page,
        },
      });
    },
    onClickRight() {
      // 危险通知
      this.$toast("失败文案");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.van-doc-demo-block__title {
  margin: 0;
  padding: 32px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 0.4rem;
  line-height: 16px;
  font-weight: bold;
}

.van-doc-demo-block__card {
  margin: 12px 12px 0;
  overflow: hidden;
  border-radius: 8px;
}

.van-doc-demo-block__title + .van-doc-demo-block__card {
  margin-top: 0;
}

.van-doc-demo-block:first-of-type .van-doc-demo-block__title {
  padding-top: 20px;
}
</style>
<style>
.demo-col {
  background: #fff;
}

.demo-col .van-doc-demo-block {
  padding: 0 16px;
}

.demo-col .van-doc-demo-block__title {
  padding-left: 0;
}

.demo-col .van-col {
  margin-bottom: 10px;
  color: #fff;
  font-size: 0.4rem;
  line-height: 30px;
  text-align: center;
  background-clip: content-box;
}

.demo-col .van-col:nth-child(odd) {
  background-color: #39a9ed;
}

.demo-col .van-col:nth-child(even) {
  background-color: #66c6f2;
}
</style>